import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { SharedService } from '../../../shared/services/shared.service';
import { Subscription } from 'rxjs';
import { Role } from '../../../const';
import { Tabs } from '../../package-center/package-center.component';
import { ChangePackage, PackagePayload } from '../../../models/package-center.model';
import { PackageService } from '../../package-center/package/package.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { DtoClientAdmin } from '../../../models/mat-account.model';
import { OpenedFromType } from '../../package-center/package/package.component';

@Component({
    selector: 'app-package-details',
    templateUrl: './package-details.component.html',
})
export class PackageDetailsComponent implements OnInit, OnDestroy, OnChanges {
  @Output() resetCreateTrigger = new EventEmitter<void>();
  @Input() openedFromMatAccountpreview: boolean = false;
  @Input() clientAccountId: number = 0;
  @Input() schoolId: number = 0;
  @Input() createTriggered: boolean = false;
  @Input() searchTriggered: boolean = false;
  @Input() searchTerm: string = "";
  @Input() assignedPackageId: number = 0;
  @Input() openedFromType: number = OpenedFromType.RequestToChangePackage;
  userRole: string[] = [];
  roles = Role;
  userEmail: string = "";
  roleName: string[] = [];
  subscription: Subscription = new Subscription();
  activeTab: string = Tabs.Package;
  showForm: boolean = false;
  updatedPackage: number = 0;
  completedSwapPackage: boolean = false;

  constructor(private sharedService: SharedService,
              private packageService: PackageService,
              private toasterService: ToastrService,
              private matAccountService: MatAccountService
  ) { }

  ngOnInit(): void {
    this.subscription.add(this.sharedService.assignedPackageId.subscribe((data) => {
      this.assignedPackageId = data;
    }));
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(Role, element)!);
    });
    this.getMatAdminDetails();
  }

  updatePackage(updatedPackage: number){
    this.updatedPackage = updatedPackage;
    if(this.updatedPackage){
      let param = {
        clientAccountId : this.clientAccountId, //Client Account
        schoolId: this.schoolId, //Independent School
        packageId: updatedPackage
      } as ChangePackage;
      this.packageService.updateAssignedPackage(param).subscribe((response)=>{
        if(response){
          this.completedSwapPackage = true;
          this.toasterService.success("Package assigned successfully");
          this.openedFromType = this.userRole.includes(this.roles.SuperAdmin) || this.userRole.includes(this.roles.AccountAdmin) ?
                                OpenedFromType.RequestToChangeAdmin : OpenedFromType.RequestToChangePackage;
          this.getMatAdminDetails();
        }
      },(err: HttpErrorResponse)=>{
        if(err.error){
          this.toasterService.error(err.error, "Error");
        }
      })
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['createTriggered']?.currentValue){
      this.showForm = true;
    }
    else{
      this.showForm = false;
    }
  }

  getMatAdminDetails(){
    this.matAccountService.getMatAdminDetails(this.userEmail, this.clientAccountId).subscribe((response: DtoClientAdmin[] | any)=>{
      if(response.length){
        this.sharedService.setAssignedPackageId(response[0].assignedPackageId);
        this.subscription.add(this.sharedService.assignedPackageId.subscribe((data) => {
          this.assignedPackageId = data;
        }));
      }
      else if(Number(sessionStorage.getItem('packageId')) > 0){
        this.sharedService.setAssignedPackageId(Number(sessionStorage.getItem('packageId')));
        this.subscription.add(this.sharedService.assignedPackageId.subscribe((data) => {
          this.assignedPackageId = data;
        }));     
      }
    }, (error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }
  requestToChangePackage() {
    this.packageService.checkIfAnyActiveRequestExists(this.userEmail).subscribe((response: boolean | any)=>{
      if(response) {
        this.toasterService.warning("An active request to change the package already exists");
      }
      else{
        this.showForm = true;
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }
  
  closePackageForm(value: boolean) {
    if (value) {
      this.showForm = false;
      this.resetCreateTrigger.emit();
    }
  }

  requestToUpdatePackage(packageDetails: PackagePayload){
    packageDetails.clientAdminEmail = this.userEmail;
    packageDetails.totalRoleCount = 1;
    this.showForm = false;
    this.packageService.createPackage(packageDetails).subscribe(response=>{
      if(response){
        this.toasterService.success("Package upgrade requested successfully", "Success");
      }
    },(error: HttpErrorResponse)=>{
      if(error.error){
        this.toasterService.error(error.error, "Error");
      }
    })
  }
  
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
